import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useIntl } from "react-intl";

import { intlFormatTime, toDate } from "helpers";
import { CalendarProjectTaskType } from "operations/schema/schema";
import { JobStyles } from "styles/JobStyles";

const classes = JobStyles.createClasses();
const StyledBox = JobStyles.defineStyles(classes);

interface ProjectTaskEventProps {
  projectTask: CalendarProjectTaskType;
  hideTimes?: boolean;
  showEngineerName?: boolean;
}

export const ProjectTaskEvent: FC<ProjectTaskEventProps> = (props: ProjectTaskEventProps) => {
  const { projectTask, hideTimes } = props;
  const intl = useIntl();
  const plannedEndText = projectTask.dateTo;
  const plannedDays =
    projectTask.dateTo && projectTask.dateFrom
      ? Math.floor(
          (toDate(projectTask.dateFrom).getTime() - toDate(projectTask.dateFrom).getTime()) /
            1000 /
            60 /
            60 /
            24
        )
      : 0;
  const dateText = projectTask.dateFrom;

  return (
    <StyledBox className="component-Job">
      <Grid container alignItems="center" wrap="nowrap">
        <Grid item minWidth="100%">
          <Grid container>
            <Grid item container justifyContent="space-between">
              <Grid item>
                <Typography variant="body2" component="h4" color="primary">
                  <span>
                    {projectTask.projectNo}/{projectTask.taskNo}
                  </span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  <span>{projectTask.addressName}</span>
                </Typography>
              </Grid>
              <Grid item className={classes.jobTime}>
                <Grid item container direction="row" alignItems="center" spacing={1}>
                  {dateText && !hideTimes && (
                    <Grid item>
                      <Typography variant="body2" color="secondary">
                        {intlFormatTime(intl, dateText)}
                        {plannedDays < 1 && plannedEndText
                          ? ` - ${intlFormatTime(intl, plannedEndText)}`
                          : plannedDays === 1
                          ? ` (+1 ${intl.formatMessage({ id: "date.day" })})`
                          : plannedDays > 1 &&
                            ` (+${plannedDays} ${intl.formatMessage({ id: "date.days" })})`}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
